import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67af7502"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-4",
  style: {"width":"600px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-center font-bold mb-2 text-center text-yellow-500" }, "Questionnaire", -1))
const _hoisted_3 = { class: "relative w-full h-96 overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "w-80"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_6 = { class: "text-sm font-semibold mb-2 text-white text-justify" }
const _hoisted_7 = { class: "text-yellow-500" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  key: 0,
  class: "flex gap-2 justify-center"
}
const _hoisted_11 = { class: "w-full h-full" }
const _hoisted_12 = { class: "grid grid-cols-2" }
const _hoisted_13 = { class: "text-blue-500 text-lg font-semibold" }
const _hoisted_14 = { class: "text-blue-500 text-lg font-semibold" }
const _hoisted_15 = { class: "text-blue-500 font-bold" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-blue-500 text-lg font-semibold" }, "Votre score Apres :", -1))
const _hoisted_17 = { class: "" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pt-2 text-yellow-500 font-bold mb-2" }, "Reponses attendues : ", -1))
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" })
], -1))
const _hoisted_21 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_TransitionGroup, {
        name: "slide",
        tag: "div",
        class: "absolute inset-0 flex transition-transform duration-300",
        style: _normalizeStyle(`transform: translateX(-${_ctx.store.currentPage * 100}%);`)
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "w-full h-full flex-shrink-0 px-4"
            }, [
              (_ctx.store.currentPage === index)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("h2", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, "Q" + _toDisplayString(index+1) + " =>", 1),
                      _createTextVNode(" " + _toDisplayString(question.question), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (option, optionIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: optionIndex,
                        class: "mb-2"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: 'option' + optionIndex,
                          value: option,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
                          class: "mr-2"
                        }, null, 8, _hoisted_8), [
                          [_vModelRadio, _ctx.selectedOption]
                        ]),
                        _createElementVNode("label", {
                          for: 'option' + optionIndex,
                          class: "text-gray-100"
                        }, _toDisplayString(option), 9, _hoisted_9)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                      class: "mt-3 bg-yellow-500 text-white py-2 px-4 rounded"
                    }, " Suivant "),
                    (_ctx.store.currentPage < _ctx.questions.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(["w-6 h-6 flex items-center justify-center rounded-full text-white", {
                  'bg-blue-500': _ctx.store.currentPage === index,
                  'bg-gray-300': _ctx.store.currentPage !== index,
                }])
                            }, _toDisplayString(index + 1), 3))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["style"]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, [
            _createTextVNode(" Votre score Avant : "),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.store.score1), 1),
            _createTextVNode(" / " + _toDisplayString(_ctx.totalPoints), 1)
          ]),
          _createElementVNode("p", _hoisted_15, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.score) + " / " + _toDisplayString(_ctx.totalPoints), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _hoisted_18,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
              return (_openBlock(), _createElementBlock("ul", {
                class: "max-w-md space-y-1 text-white list-inside dark:text-white",
                key: index
              }, [
                _createElementVNode("li", _hoisted_19, [
                  _createElementVNode("p", null, "Q" + _toDisplayString(index+1) + " ) => ", 1),
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(question.correctAnswer), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_RouterLink, { to: "/categorie" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "bg-blue-600 text-white py-2 px-3 rounded-md",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.store.reinitialiser && _ctx.store.reinitialiser(...args)))
              }, " Fermer l'experience ")
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, _ctx.store.currentPage >= _ctx.questions.length]
      ])
    ])
  ]))
}